export default "__VITE_ASSET__Cerns$$K__"